import { render, staticRenderFns } from "./AdminVacancyRoomQuery.vue?vue&type=template&id=3520e729"
import script from "./AdminVacancyRoomQuery.vue?vue&type=script&lang=js"
export * from "./AdminVacancyRoomQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports